<div *ngIf="workflowItem"
	[ngClass]="viewMode"
	[appWorkflowItem]="workflowItem"
	[appWorkflowItemData]="item"
>
	<div nz-row [nzGutter]="[16, 16]" class="top-row-with-sidebar-extra">
		<div nz-col [nzSpan]="viewMode === 'compact' ? 18 : 23">
			<div nz-row [nzGutter]="[16, 16]">
				<div nz-col *ngIf="viewMode === 'compact'" >
					<app-splitbutton [elements]="[cancelWorkflowSplitbutton]"></app-splitbutton>
				</div>
				<div nz-col *ngIf="viewMode === 'wizard'" >
					<app-splitbutton [elements]="[overviewWorkflowSplitbutton]"></app-splitbutton>
				</div>
			</div>
		</div>
		<div nz-col [nzSpan]="viewMode === 'compact' ? 6 : 0" *ngIf="viewMode === 'compact'">
			<workflow-projektsidebar *ngIf="workflowCategories"
									[currentParticipant]="participant"
			>
			</workflow-projektsidebar>
		</div>
	</div>
	<div *ngIf="viewMode === 'compact'">
		<div nz-row [nzGutter]="[16, 16]">
			<div nz-col [nzSpan]="18">
				<nz-card nzTitle="{{workflowItem.name}}">
					<div class="card-body" *ngTemplateOutlet="overviewElements">
					</div>
				</nz-card>
			</div>
		</div>
	</div>
	<div *ngIf="viewMode === 'wizard'">
		<h1>{{workflowItem.name}}</h1>
		<div *ngTemplateOutlet="overviewElements"></div>
	</div>

	<ng-template #overviewElements>
		<div *ngIf="workflowItem != null" nz-row [nzGutter]="[16, 6]">
			<div *ngFor="let question of workflowItem.groups, let i = index" nz-col [nzSpan]="24" [nzXXl]="6" [nzXl]="8" [nzLg]="12" [nzMd]="24"
				[hidden]="groupStatus[i] === 'disabled'"
			>
				<nz-card class="card-tile">
					<nz-card-meta [nzTitle]="questionGroup" nzDescription="{{ question.preface }}" [nzAvatar]="statusAvatar"></nz-card-meta>
					<div *ngIf="question.groupOverview?.length" class="question-card-data div-table">
						<workflow-overview-item *ngFor="let item of question.groupOverview" [config]="item" class="div-table-line"></workflow-overview-item>
					</div>
				</nz-card>

				<ng-template #questionGroup>
					<div class="question-card-title">{{question.title}}</div>
				</ng-template>

				<ng-template #statusAvatar>
					<nz-avatar nzIcon="check" *ngIf="groupStatus[i] === 'finished'" class="group-finished"></nz-avatar>
					<nz-avatar nzIcon="edit" *ngIf="groupStatus[i] === 'edited'" class="group-edited"></nz-avatar>
					<nz-avatar nzIcon="file" *ngIf="groupStatus[i] === 'unstarted'" class="group-unstarted"></nz-avatar>
				</ng-template>
			</div>
		</div>
	</ng-template>

</div>

<ng-template #workflowStartButton>
	<app-splitbutton *ngIf="!workflowItemStatus?.started && !allValid" [elements]="[startWorkflowSplitbutton]"></app-splitbutton>
	<app-splitbutton *ngIf="workflowItemStatus?.started && !allValid" [elements]="[continueWorkflowSplitbutton]"></app-splitbutton>
	<app-splitbutton *ngIf="allValid" [elements]="[finishWorkflowSplitbutton]" [isSpin]="!item?.data"></app-splitbutton>
</ng-template>

<nz-modal [(nzVisible)]="isConfirmDialogVisible"
			nzTitle="{{ 'workflow.end' | translate }}"
			(nzOnCancel)="handleCancelToDismissFinishWorkflow()"
			(nzOnOk)="handleOkToFinishWorkflow()"
>
	<ng-container *nzModalContent>
		{{ 'workflow.endWarning' | translate }}
	</ng-container>
</nz-modal>
